import type * as SchemaTypes from '../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchTraineeAssessmentProgramsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  filter?: SchemaTypes.InputMaybe<SchemaTypes.ProgramFilteringRule>;
}>;


export type FetchTraineeAssessmentProgramsQuery = (
  { __typename: 'Query' }
  & { programs: (
    { __typename: 'PaginatedProgram' }
    & Pick<SchemaTypes.PaginatedProgram, 'count'>
    & { items: Array<(
      { __typename: 'Program' }
      & TraineeAssessmentProgramItemDataFragment
    )> }
  ) }
);

export type FetchLaunchItemsQueryVariables = SchemaTypes.Exact<{
  assessmentRunId: SchemaTypes.Scalars['ObjectID']['input'];
  subCategory?: SchemaTypes.InputMaybe<SchemaTypes.ModuleSubCategory>;
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
}>;


export type FetchLaunchItemsQuery = (
  { __typename: 'Query' }
  & { moduleInstancesForLaunch: (
    { __typename: 'PaginatedModuleInstanceLaunchItem' }
    & Pick<SchemaTypes.PaginatedModuleInstanceLaunchItem, 'count'>
    & { items: Array<(
      { __typename: 'ModuleInstanceLaunchItem' }
      & TraineeAssessmentModuleInstanceLaunchItemDataFragment
    )> }
  ) }
);

export type TraineeAssessmentModuleInstanceLaunchItemDataFragment = (
  { __typename: 'ModuleInstanceLaunchItem' }
  & Pick<SchemaTypes.ModuleInstanceLaunchItem, 'targetUserId' | 'targetFullName' | 'isCompleted' | 'completedAt' | 'resultId'>
  & { moduleInstance: (
    { __typename: 'ModuleInstance' }
    & TraineeAssessmentModuleInstanceDataFragment
  ) }
);

export type TraineeAssessmentProgramItemDataFragment = (
  { __typename: 'Program' }
  & Pick<SchemaTypes.Program, 'id' | 'name' | 'description'>
  & { assessmentRuns: Array<(
    { __typename: 'AssessmentRun' }
    & TraineeAssessmentRunsDataFragment
  )>, courseInstance: (
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'id'>
    & { executionSequence: Array<SchemaTypes.Maybe<(
      { __typename: 'ExecutionSequence' }
      & Pick<SchemaTypes.ExecutionSequence, 'moduleInstanceId' | 'order'>
      & { moduleInstance?: SchemaTypes.Maybe<(
        { __typename: 'ModuleInstance' }
        & TraineeAssessmentModuleInstanceDataFragment
      )> }
    )>> }
  ) }
);

export type TraineeAssessmentRunsDataFragment = (
  { __typename: 'AssessmentRun' }
  & Pick<SchemaTypes.AssessmentRun, 'endDate' | 'groupId' | 'id' | 'name' | 'programId' | 'startDate' | 'status'>
);

export type TraineeAssessmentModuleInstanceDataFragment = (
  { __typename: 'ModuleInstance' }
  & Pick<SchemaTypes.ModuleInstance, 'id' | 'moduleDefinitionIdentifier' | 'name' | 'description'>
  & { moduleDefinition?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentModuleDefinition' }
    & TraineeAssessmentBaseModuleDefinitionData_AssessmentModuleDefinition_Fragment
  ) | (
    { __typename: 'ExternalIntegrationModuleDefinition' }
    & TraineeAssessmentBaseModuleDefinitionData_ExternalIntegrationModuleDefinition_Fragment
  ) | (
    { __typename: 'ReportingModuleDefinition' }
    & TraineeAssessmentBaseModuleDefinitionData_ReportingModuleDefinition_Fragment
  ) | (
    { __typename: 'TrainingModuleDefinition' }
    & TraineeAssessmentBaseModuleDefinitionData_TrainingModuleDefinition_Fragment
  )> }
);

export type TraineeAssessmentBaseModuleDefinitionData_AssessmentModuleDefinition_Fragment = (
  { __typename: 'AssessmentModuleDefinition' }
  & Pick<SchemaTypes.AssessmentModuleDefinition, 'minDurationMinutes' | 'maxDurationMinutes' | 'subCategory' | 'identifier' | 'name' | 'description' | 'groupingKey'>
);

export type TraineeAssessmentBaseModuleDefinitionData_ExternalIntegrationModuleDefinition_Fragment = (
  { __typename: 'ExternalIntegrationModuleDefinition' }
  & Pick<SchemaTypes.ExternalIntegrationModuleDefinition, 'identifier' | 'name' | 'description' | 'groupingKey'>
);

export type TraineeAssessmentBaseModuleDefinitionData_ReportingModuleDefinition_Fragment = (
  { __typename: 'ReportingModuleDefinition' }
  & Pick<SchemaTypes.ReportingModuleDefinition, 'identifier' | 'name' | 'description' | 'groupingKey'>
);

export type TraineeAssessmentBaseModuleDefinitionData_TrainingModuleDefinition_Fragment = (
  { __typename: 'TrainingModuleDefinition' }
  & Pick<SchemaTypes.TrainingModuleDefinition, 'minDurationMinutes' | 'maxDurationMinutes' | 'subCategory' | 'identifier' | 'name' | 'description' | 'groupingKey'>
);

export type TraineeAssessmentBaseModuleDefinitionDataFragment = TraineeAssessmentBaseModuleDefinitionData_AssessmentModuleDefinition_Fragment | TraineeAssessmentBaseModuleDefinitionData_ExternalIntegrationModuleDefinition_Fragment | TraineeAssessmentBaseModuleDefinitionData_ReportingModuleDefinition_Fragment | TraineeAssessmentBaseModuleDefinitionData_TrainingModuleDefinition_Fragment;

export const TraineeAssessmentBaseModuleDefinitionDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentBaseModuleDefinitionData on BaseModuleDefinition {
  identifier
  name
  description
  groupingKey
  ... on AssessmentModuleDefinition {
    minDurationMinutes
    maxDurationMinutes
    subCategory
  }
  ... on TrainingModuleDefinition {
    minDurationMinutes
    maxDurationMinutes
    subCategory
  }
}
    `;
export const TraineeAssessmentModuleInstanceDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentModuleInstanceData on ModuleInstance {
  id
  moduleDefinitionIdentifier
  name
  description
  moduleDefinition {
    ...TraineeAssessmentBaseModuleDefinitionData
  }
}
    `;
export const TraineeAssessmentModuleInstanceLaunchItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentModuleInstanceLaunchItemData on ModuleInstanceLaunchItem {
  moduleInstance {
    ...TraineeAssessmentModuleInstanceData
  }
  targetUserId
  targetFullName
  isCompleted
  completedAt
  resultId
}
    `;
export const TraineeAssessmentRunsDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentRunsData on AssessmentRun {
  endDate
  groupId
  id
  name
  programId
  startDate
  status
}
    `;
export const TraineeAssessmentProgramItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TraineeAssessmentProgramItemData on Program {
  id
  name
  description
  assessmentRuns {
    ...TraineeAssessmentRunsData
  }
  courseInstance {
    id
    executionSequence {
      moduleInstanceId
      order
      moduleInstance {
        ...TraineeAssessmentModuleInstanceData
      }
    }
  }
}
    `;
export const FetchTraineeAssessmentProgramsDocument = /*#__PURE__*/ gql`
    query FetchTraineeAssessmentPrograms($companyId: ObjectID!, $filter: ProgramFilteringRule) {
  programs(companyId: $companyId, filter: $filter) {
    count
    items {
      ...TraineeAssessmentProgramItemData
    }
  }
}
    ${TraineeAssessmentProgramItemDataFragmentDoc}
${TraineeAssessmentRunsDataFragmentDoc}
${TraineeAssessmentModuleInstanceDataFragmentDoc}
${TraineeAssessmentBaseModuleDefinitionDataFragmentDoc}`;

/**
 * __useFetchTraineeAssessmentProgramsQuery__
 *
 * To run a query within a React component, call `useFetchTraineeAssessmentProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTraineeAssessmentProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTraineeAssessmentProgramsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTraineeAssessmentProgramsQuery(baseOptions: Apollo.QueryHookOptions<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables> & ({ variables: FetchTraineeAssessmentProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables>(FetchTraineeAssessmentProgramsDocument, options);
      }
export function useFetchTraineeAssessmentProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables>(FetchTraineeAssessmentProgramsDocument, options);
        }
export function useFetchTraineeAssessmentProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables>(FetchTraineeAssessmentProgramsDocument, options);
        }
export type FetchTraineeAssessmentProgramsQueryHookResult = ReturnType<typeof useFetchTraineeAssessmentProgramsQuery>;
export type FetchTraineeAssessmentProgramsLazyQueryHookResult = ReturnType<typeof useFetchTraineeAssessmentProgramsLazyQuery>;
export type FetchTraineeAssessmentProgramsSuspenseQueryHookResult = ReturnType<typeof useFetchTraineeAssessmentProgramsSuspenseQuery>;
export type FetchTraineeAssessmentProgramsQueryResult = Apollo.QueryResult<FetchTraineeAssessmentProgramsQuery, FetchTraineeAssessmentProgramsQueryVariables>;
export const FetchLaunchItemsDocument = /*#__PURE__*/ gql`
    query FetchLaunchItems($assessmentRunId: ObjectID!, $subCategory: ModuleSubCategory, $pagination: Pagination) {
  moduleInstancesForLaunch(
    assessmentRunId: $assessmentRunId
    subCategory: $subCategory
    pagination: $pagination
  ) {
    count
    items {
      ...TraineeAssessmentModuleInstanceLaunchItemData
    }
  }
}
    ${TraineeAssessmentModuleInstanceLaunchItemDataFragmentDoc}
${TraineeAssessmentModuleInstanceDataFragmentDoc}
${TraineeAssessmentBaseModuleDefinitionDataFragmentDoc}`;

/**
 * __useFetchLaunchItemsQuery__
 *
 * To run a query within a React component, call `useFetchLaunchItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLaunchItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLaunchItemsQuery({
 *   variables: {
 *      assessmentRunId: // value for 'assessmentRunId'
 *      subCategory: // value for 'subCategory'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFetchLaunchItemsQuery(baseOptions: Apollo.QueryHookOptions<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables> & ({ variables: FetchLaunchItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables>(FetchLaunchItemsDocument, options);
      }
export function useFetchLaunchItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables>(FetchLaunchItemsDocument, options);
        }
export function useFetchLaunchItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables>(FetchLaunchItemsDocument, options);
        }
export type FetchLaunchItemsQueryHookResult = ReturnType<typeof useFetchLaunchItemsQuery>;
export type FetchLaunchItemsLazyQueryHookResult = ReturnType<typeof useFetchLaunchItemsLazyQuery>;
export type FetchLaunchItemsSuspenseQueryHookResult = ReturnType<typeof useFetchLaunchItemsSuspenseQuery>;
export type FetchLaunchItemsQueryResult = Apollo.QueryResult<FetchLaunchItemsQuery, FetchLaunchItemsQueryVariables>;